import { EMPTY_IMAGE } from '../../common';
import InitialAvatar from '../InitialAvatar';

const Avatar = ({ image, name, heightClass = 'h-10', widthClass = 'w-10', textLarge = false }) => {
    const hasImage = image && image !== EMPTY_IMAGE.src && image !== EMPTY_IMAGE.jpgsrc;
    if (hasImage) {
        return (
            <img
                className={`${heightClass} ${widthClass} rounded-full`}
                src={image}
                alt={name}
                onError={(e) => (e.target.src = EMPTY_IMAGE.src)}
            />
        );
    }
    return (
        <InitialAvatar
            username={name}
            heightClass={heightClass}
            widthClass={widthClass}
            textLarge={textLarge}
        />
    );
};

export default Avatar;
